import { X as attr_class, a2 as stringify, _ as store_get, $ as unsubscribe_stores } from "./index2.js";
import { w as writable } from "./index.js";
const loading = writable(true);
function Loading($$renderer) {
  var $$store_subs;
  $$renderer.push(`<div${attr_class(`w-full h-full fixed top-0 left-0 bg-gray-950 flex items-center justify-center transition-all duration-300 ${stringify(store_get($$store_subs ??= {}, "$loading", loading) ? "opacity-100" : "opacity-0 pointer-events-none")} z-50`, "svelte-1va4w2i")}><span class="loader svelte-1va4w2i"></span></div>`);
  if ($$store_subs) unsubscribe_stores($$store_subs);
}
export {
  Loading as L
};
